import { ref, inject } from 'vue'
import { useUrlParams } from './useUrlParams'
import axios from 'axios'
import { scrollToTop, setElHeight } from '../functions/helpers'

export function useFilter(route) {

    const {
        url,
        params,
        getParamsFromUrl
    } = useUrlParams()

    const filterForm    = ref(null)
    const loading       = ref(false)
    const results       = ref([])
    const pagination    = ref('')
    const filterVisible = ref(false)

    const constants = inject('constants')

    const handleChange = (page) => {
        let formData = new FormData(filterForm.value)

        params.set('page', page)

        setParametersToUrl(formData)

        getData(formData, page)
    }

    const getData = (data, page) => {

        loading.value = true

        if ( page !== null && page !== undefined ) {
            data.append('page', parseInt(page))
        }

        axios.post(route, data)
            .then( response => {
                results.value    = response.data.products
                pagination.value = response.data.pagination
                loading.value    = false
                runPaginationActions()
                if ( constants.width < 991 ) {
                    closeFilter()
                    scrollToTop(500)
                }
                setTimeout( () => {
                    setItemHeights()
                }, 500)

            }).catch((error) => flash(error, 'danger'))
    }

    const makeFormData = () => {
        let formData = new FormData()

        params.forEach( (value, key) => {
            formData.append(key, value.split(','))
        })

        return formData
    }

    const setParametersToUrl = (formData) => {

        let brands     = [],
            properties = [],
            badges     = []

        formData.forEach((value, key) => {

            if ( key === 'brands[]' ) brands.push(value)
            if ( key === 'badges[]' ) badges.push(value)
            if ( key.includes('properties') ) properties.push(value)

            if ( key !== 'brands[]' && key !=='badges[]' && !key.includes('properties') )
                params.set(key, value)
        });


        params.set('brands', brands.toString())
        params.set('badges', badges.toString())
        params.set('properties', properties.toString())

        url.search = params.toString()

        window.history.replaceState(null, null, url.toString())
    }

    const runPaginationActions = () => {

        setTimeout( () => {
            document.querySelectorAll('.js-next-page').forEach( item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    let page = item.getAttribute('data-page')
                    params.set('page', page)
                    handleChange(page)
                    if ( constants.width > 991 ) {
                        scrollToTop(500)
                    }
                })
            })
        }, 250)
    }

    const setItemHeights = () => {
        setElHeight(document.querySelectorAll('.product-listing .product h4'))
        setElHeight(document.querySelectorAll('.product-listing .product p.excerpt'))
        setElHeight(document.querySelectorAll('.product-listing .product .description'))
        setElHeight(document.querySelectorAll('.product-listing .product .bottom'))
    }

    const closeFilter = () => {
        filterVisible.value = false

        if ( window.innerWidth < 991 ) {
            document.getElementById('overlay')
                .classList.remove('visible')
        }
    }

    const openFilter = () => {
        filterVisible.value = true

        if ( window.innerWidth < 991 ) {
            document.getElementById('overlay')
                .classList.add('visible')
        }
    }

    // const handleProperties = () => {}

    return {
        filterForm,
        params,
        loading,
        // results: toRef(state, 'results'),
        results,
        pagination,
        filterVisible,
        handleChange,
        makeFormData,
        getParamsFromUrl,
        setParametersToUrl,
        closeFilter,
        openFilter
    }
}
